import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Change deviceId to filter events list
 *
 * @private
 */
export const changeDeviceIdsForEvents = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('ui/deviceIdsForEvents/change', async (deviceIds, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/ui/changeDeviceIdsForEvents', {
      category: 'rpc',
      type: 'rpc/ui/changeDeviceIdsForEvents',
      deviceIds,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {changeCalendarRange}`,
      { tags: ['rpc', 'ui', 'deviceIdsForEvents'], info: deviceIds },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Change DeviceId for Events Failed`,
      error,
    })
  }
})
